import type { SearchStore, StoreSearchParams, StoreV2, WebStore } from '@libs/common-types';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export async function getStoreById(storeId: string, headers?: HeadersInit) {
    const url = CWEA_ENDPOINTS.stores.getStoreById(storeId);
    return await cweaClient.get<StoreV2>(url, { useOldFetch: true, headers });
}

export async function getWebStoreById() {
    const url = CWEA_ENDPOINTS.stores.getWebStoreById();
    return await cweaClient.get<WebStore>(url, { useOldFetch: true });
}

export async function searchStores(params: StoreSearchParams) {
    const url = CWEA_ENDPOINTS.stores.search(params);
    return await cweaClient.get<SearchStore[]>(url, { useOldFetch: true });
}
